module.exports = __webpack_public_path__ + "static/media/gyunwonlogo.1f6305aa.png";